module.exports = __webpack_public_path__ + "img/bedroom-checked.e2a6be89.jpg";